import { ExploreContext } from '/Scripts/common/react-new/exploreContext.jsx';
import { format } from '/Scripts/modules/reactHelper.js'

export const LandingPage = ({ }) => {
	const [globalState, setGlobalState] = React.useContext(ExploreContext);

	const proLandingPageUrl = "/Home/HowToActivate";
	const nomadLandingPageUrl = "/Home/NomadDevicesLandingPage";
	const exploreGooglePlayUrl = "https://play.google.com/store/apps/details?id=com.garmin.android.apps.explore";
	const exploreAppStoreUrl = "https://apps.apple.com/app/garmin-explore/id1276675721";
	const messengerSmartUrl = "https://messenger.garmin.com/app";
	const earthmateSmartUrl = "https://connect.garmin.com/mobile-link/earthmate";
	const alphaSmartUrl = "https://connect.garmin.com/mobile-link/alpha";
	const treadSmartUrl = "https://tread.automotive.garmin.com/app";
	const garminAppsPageUrl = "https://www.garmin.com/c/apps/";

	const adventuresFeaturesArray = [
		{
			imageSrc: "/Content/images/LandingPage/wifi.png",
			label: globalState.resources.ACCOUNT_LOGON_OFF_GRID_ADVENTURES_NO_SERVICE_TEXT
		},
		{
			imageSrc: "/Content/images/LandingPage/gps-device.png",
			label: format(globalState.resources.ACCOUNT_LOGON_OFF_GRID_ADVENTURES_GPS_DEVICE_TEXT, <sup key="1">1</sup>)
		},
		{
			imageSrc: "/Content/images/LandingPage/download-maps.png",
			label: globalState.resources.ACCOUNT_LOGON_OFF_GRID_ADVENTURES_DOWNLOAD_MAPS
		},
		{
			imageSrc: "/Content/images/LandingPage/share-activities.png",
			label: globalState.resources.ACCOUNT_LOGON_OFF_GRID_ADVENTURES_EXPLORE_WEBSITE
		},
		{
			imageSrc: "/Content/images/LandingPage/satellite-text.png",
			label: format(globalState.resources.ACCOUNT_LOGON_OFF_GRID_ADVENTURES_SATELLITE_TEXT, <sup key="2">2</sup>, <sup key="3">3</sup>)
		},
		{
			imageSrc: "/Content/images/LandingPage/cloud-storage.png",
			label: globalState.resources.ACCOUNT_LOGON_OFF_GRID_ADVENTURES_CLOUD_STORAGE
		},
	];

	const appInfoArray = [
		{
			imageSrc: "/Content/images/Apps/MessengerApp.png",
			label: globalState.resources.COMMON_MESSENGER,
			smartUrl: messengerSmartUrl
		},
		{
			imageSrc: "/Content/images/Apps/EarthmateApp.png",
			label: globalState.resources.HOME_EARTHMATE,
			smartUrl: earthmateSmartUrl
		},
		{
			imageSrc: "/Content/images/Apps/AlphaApp.png",
			label: globalState.resources.COMMON_ALPHA,
			smartUrl: alphaSmartUrl
		},
		{
			imageSrc: "/Content/images/Apps/TreadApp.png",
			label: globalState.resources.COMMON_TREAD,
			smartUrl: treadSmartUrl
		},
	];

	return (
		<React.Fragment>
			<div className="ex-landing-page-activation-container">
				<div className="ex-landing-page-activation-content-container">
					<div className="ex-landing-page-activation-content-container-column">
						<div className="ex-landing-page-activation-title-container">
							<h2 className="ex-landing-page-activation-header">
								{globalState.resources.ACCOUNT_LOGON_HERE_TO_ACTIVATE}
							</h2>
                            <h4>{globalState.resources.ACCOUNT_LOGON_CHOOSE_YOUR_DEVICE}</h4>
						</div>
						<div className="ex-landing-page-activation-image-button-container-group">
							<div className="ex-landing-page-activation-image-button-container">
								<img id="mini2_img" src="/Content/images/LandingPage/mini2.png" />
								<a className="btn btn-primary" href={proLandingPageUrl}>
									{globalState.resources.ACCOUNT_LOGON_SATELLITE_COMMUNICATORS}
								</a>
							</div>
							<div className="ex-landing-page-activation-image-button-container">
								<img id="tread_img" src="/Content/images/LandingPage/tread-overland.png" />
								<a className="btn btn-primary" href={nomadLandingPageUrl}>
									{globalState.resources.ACCOUNT_LOGON_TREAD_OFF_ROAD_NAVIGATORS}
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="ex-landing-page-activation-small-group-hike-img">
				<img src="/Content/images/LandingPage/group-hike-small-hr.jpg" />
			</div>

			<div className="d-flex flex-column">
				<div className="ex-landing-page-adventures-container">
					<h2 className="ex-landing-page-adventures-header">{globalState.resources.ACCOUNT_LOGON_OFF_GRID_ADVENTURES}</h2>
					<div className="ex-landing-page-adventures-features-container">
						{adventuresFeaturesArray.map((feature, index) =>
							<div className="ex-landing-page-adventures-feature" key={index}>
								<img src={feature.imageSrc} />
								<p>
									{feature.label}
								</p>
							</div>
						)}
					</div>
				</div>


				<div className="ex-landing-page-explore-mobile-container">
					<div className="ex-landing-page-explore-mobile-content">
						<h2>
							{globalState.resources.ACCOUNT_LOGON_EXPLORE_MOBILE_HEADER}
						</h2>
						<p>
							{globalState.resources.ACCOUNT_LOGON_EXPLORE_MOBILE_DESCRIPTION}
						</p>
						<div className="ex-landing-page-explore-mobile-app-store-button-wrapper">
							<a href={exploreAppStoreUrl} target="_blank">
								<img src="/Content/images/Apps/AppStore.png" />
							</a>
							<a href={exploreGooglePlayUrl} target="_blank">
								<img src="/Content/images/Apps/PlayStore.png" />
							</a>

						</div>
					</div>

					<img className="ex-landing-page-explore-mobile-app-img" src="/Content/images/LandingPage/explore-mobile.png" />
				</div>
			</div>

			<div className="ex-landing-page-explore-web-container">
				<div className="ex-landing-page-explore-web-content">
					<h2>
						{globalState.resources.HOME_GARMIN_EXPLORE_WEBSITE}
					</h2>
					<img id="app_route_sync_img" src="/Content/images/LandingPage/explore-app-route-sync.png" />
					<p>
						{globalState.resources.ACCOUNT_LOGON_EXPLORE_WEBSITE_DESCRIPTION}
					</p>
					<ul>
						<li>{globalState.resources.ACCOUNT_LOGON_EXPLORE_WEBSITE_FEATURE_CREATE_ROUTES}</li>
						<li>{globalState.resources.ACCOUNT_LOGON_EXPLORE_WEBSITE_FEATURE_SHARE_ROUTES}</li>
						<li>{globalState.resources.ACCOUNT_LOGON_EXPLORE_WEBSITE_FEATURE_RECORDED_ACTIVITIES}</li>
						<li>{globalState.resources.ACCOUNT_LOGON_EXPLORE_WEBSITE_FEATURE_CLOUD_STORAGE}</li>
					</ul>
				</div>

				<img id="web_big_img" src="/Content/images/LandingPage/explore-site-big.png" />
			</div>

			<div className="ex-landing-page-apps-container">
				<h2 className="ex-landing-page-apps-header">
					{globalState.resources.ACCOUNT_LOGON_DIFFERENT_APP}
				</h2>
				<div className="ex-landing-page-apps-icon-container">
					{appInfoArray.map((app) =>
						<a href={app.smartUrl} target="_blank" className="text-reset text-decoration-none" key={app.label}>
							<div className="ex-landing-page-apps-icon">
								<img src={app.imageSrc} />
								<p>
									{app.label}
								</p>
							</div>
						</a>
					)}
				</div>

				<p className="ex-landing-page-apps-more-link">
					<a href={garminAppsPageUrl} target="_blank">{globalState.resources.ACCOUNT_LOGON_MORE_APPS}</a>
				</p>

				<div className="ex-landing-page-apps-additional-info">
					<p>
						<sup>1</sup>{globalState.resources.ACCOUNT_LOGON_COMPATIBLE_DEVICES_TAB}<br />
						<sup>2</sup>{globalState.resources.ACCOUNT_LOGON_SATELLITE_SUBSCRIPTION_REQUIRED}<br />
						<sup>3</sup>{globalState.resources.ACCOUNT_LOGON_CLOUD_REQUIRES_GARMIN_ACCOUNT}
					</p>

					<p>
						{globalState.resources.ACCOUNT_WIFI_TRADEMARK}
					</p>

					<p>
						{globalState.resources.ACCOUNT_IRIDIUM_ACCESS_REQUIRES_ACCOUNT}
					</p>
				</div>
			</div>

			<p className="ex-landing-page-service-and-trade-mark-section">
				{globalState.resources.ACCOUNT_APP_STORE_SERVICE_MARK} {globalState.resources.ACCOUNT_PLAY_STORE_TRADEMARK}
			</p>

			<div className="ex-landing-page-garmin-logo-footer">
				<img src="/Content/images/LandingPage/garmin-logo-black.png" />
			</div>
		</React.Fragment>
	);
}
